<!--客户管理 - 客户列表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="statusForm" ref="statusForm" style="margin: 0">

          <el-form-item label="副仓：" v-if="useSubWarehouse">
            <el-select size="medium" filterable clearable multiple collapse-tags v-model="statusForm.SUB_WAREHOUSE"
              placeholder="请选择副仓" style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID" />
            </el-select>
          </el-form-item>

          <el-form-item label="客户名称：">
            <el-input size="medium" placeholder="请输入客户名称" minlength="2" maxlength="10" v-model="statusForm.NAME"
              clearable @keyup.enter.native="filtrate" />
          </el-form-item>

          <el-form-item label="状态：">
            <el-select size="medium" filterable v-model="statusForm.RELATION_STATUS" placeholder="请选择供应商"
              :clearable="false">
              <el-option v-for="item in STATUS_LIST" :key="item.status" :label="item.name" :value="item.status">
              </el-option>
            </el-select>
          </el-form-item>

          <el-button size="medium" type="primary" @click="filtrate" :loading="loading1">筛选</el-button>

        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addCustomer" v-show="fun_dic[107000102]">新增客户</el-button>
        <el-button size="medium" @click="importCustomer" v-show="fun_dic[107000103]">导入客户</el-button>
        <el-button size="medium" @click="openExport" v-if="usePriceType == 1">导入报价</el-button>
        <el-button size="medium" @click="exportRelationship" v-if="usePriceType == 1">导入供应关系</el-button>
        <el-button size="medium" type="primary" plain @click="exportCustomer">导出客户</el-button>
        <el-button size="medium" type="primary" plain @click="exportProject">导出项目点</el-button>
        <el-button size="medium" type="primary" plain @click="exportDK">导出档口</el-button>
        <!-- <el-button size="medium" @click="updatePrice">销售价及订单价更新</el-button> -->
        <tooltip-button :disabled="Boolean(this.selectedList.length)" buttonText="批量导入客户编码" tipContent="请先勾选客户"
          @click="importCustomerCodeDialog = true">
        </tooltip-button>
        <el-button size="medium" type="primary" plain @click="matchCustomer">匹配客户</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-tabs type="border-card" @tab-click="handleTabClick">
        <el-tab-pane label="团餐客户列表">
          <el-col>
            <el-table stripe border :data="tableData" @selection-change="onSelectionChange">
              <el-table-column type="selection" width="50"></el-table-column>
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column label="所属仓" prop="SUPPLIER_NAME" v-if="useSubWarehouse" min-width="182" />
              <el-table-column label="客户名称" prop="NAME" min-width="168"></el-table-column>
              <el-table-column label="客户简称" prop="AB_NAME"></el-table-column>
              <el-table-column label="首字母缩写" prop="CODE" width="100"></el-table-column>
              <el-table-column label="公司代码" prop="COMPANY_CODE"></el-table-column>
              <el-table-column label="联系人" prop="CONTACT_NAME"></el-table-column>
              <el-table-column label="联系电话" prop="CONTACT_PHONE"></el-table-column>
              <el-table-column label="地址" prop="ADDRESS"></el-table-column>
              <el-table-column label="单位模式" min-width="100" v-if="showUnitModeColumn">
                <template slot-scope="scope">
                  <span>{{ showUnitMode(scope.row.UNIT_MODE) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="下单类型">
                <template slot-scope="scope">
                  <el-tag>{{ showOrderType[scope.row.ORDER_TYPE - 1] }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="自动签回">
                <template slot-scope="scope">
                  <span>{{ judgeIS_ALL_AUTOAUDIT[Number(scope.row.IS_ALL_AUTOAUDIT)] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="打印模板匹配" width="120">
                <template slot-scope="scope">
                  <el-tag>{{ printTemplate(scope.row) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="代采状态">
                <template slot-scope="scope">
                  <el-tag>{{ IS_PRINCIPAL_CLIENT[Number(scope.row.IS_PRINCIPAL_CLIENT)] }}</el-tag>
                </template>
              </el-table-column>
              <!-- <el-table-column label="代采绑定供应商" prop="PRINCIPAL_NAME" width="150"></el-table-column> -->
              <el-table-column label="代采绑定送货方" prop="TRUSTEE_NAME" width="120"></el-table-column>
              <el-table-column label="合同开始日期" prop="START_DATE" width="120"></el-table-column>
              <el-table-column label="合同结束日期" prop="END_DATE" width="120"></el-table-column>
              <el-table-column label="操作" min-width="250" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" icon="el-icon-view" :disabled="scope.row.STATUS == 0"
                    @click="projectList(scope.row)">
                    查看项目点
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-goods" @click="productsList(scope.row)">
                    供应产品
                  </el-button>
                  <el-button type="text" size="small" @click="codeManage(scope.row)"
                    v-show="scope.row.ORDER_TYPE !== 1">
                    客户产品编码
                  </el-button>
                  <el-button type="text" size="small" @click="persontList(scope.row)"
                    v-show="scope.row.ORDER_TYPE == 2">
                    人员管理
                  </el-button>
                  <el-button type="text" size="small" @click="updatePrice(scope.row)" v-show="fun_dic[107000101]">
                    销售价及订单价更新
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-setting" @click="purchaseChange(scope.row)">
                    代采配置
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-setting" :disabled="scope.row.STATUS == 1"
                    @click="printChange(scope.row, 1)">
                    打印配置
                  </el-button>
                  <el-button type="text" size="small" @click="commoHabits(scope.row)">客户习惯</el-button>
                  <el-button type="text" size="small" icon="el-icon-edit" @click="openEdit(scope.row)"
                    v-show="scope.row.ORDER_TYPE !== 1">
                    修改
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-check" v-if="scope.row.RELATION_STATUS == 0"
                    style="color: rgb(103, 194, 58)" @click="startCustomer(scope.row)" v-show="scope.row.STATUS !== 1">
                    启用
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-close" v-else @click="stopCustomer(scope.row)"
                    style="color: rgb(245, 108, 108)" v-show="scope.row.STATUS !== 1">
                    禁用
                  </el-button>
                  <el-button type="text" size="small" @click="openUnitModeDialog(scope.row)" v-if="showUnitModeColumn">
                    单位模式
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="供应商客户列表">
          <el-col :span="24">
            <el-table stripe border :data="tableData">
              <el-table-column label="序号" type="index" width="50"></el-table-column>
              <el-table-column label="客户名称" prop="NAME"></el-table-column>
              <el-table-column label="客户简称" prop="AB_NAME"></el-table-column>
              <el-table-column label="首字母缩写" prop="CODE"></el-table-column>
              <el-table-column label="打印模板匹配" width="150">
                <template slot-scope="scope">
                  <el-tag>{{ printTemplate(scope.row) }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="公司代码" prop="COMPANY_CODE"></el-table-column>
              <el-table-column label="地址" prop="ADDRESS"></el-table-column>
              <el-table-column label="代采绑定供应商" prop="PRINCIPAL_NAME" width="150"></el-table-column>
              <el-table-column label="代采绑定送货方" prop="TRUSTEE_NAME" width="150"></el-table-column>
              <el-table-column label="操作" min-width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" icon="el-icon-view" @click="purchaseChange(scope.row)">
                    代采配置
                  </el-button>
                  <el-button type="text" size="small" icon="el-icon-view" @click="printChange(scope.row, 2)">
                    打印配置
                  </el-button>
                  <el-button type="text" size="small" @click="commoHabits(scope.row)">常用习惯</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-tab-pane>
      </el-tabs>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog :title="addFormTitle" center :visible.sync="addFormVisible" width="600px" @close="close('addForm')">
          <el-form size="small" :model="addForm" ref="addForm" :rules="rules">
            <el-form-item label="客户名称：" prop="NAME" :label-width="formLabelWidth">
              <el-input v-model.trim="addForm.NAME"></el-input>
            </el-form-item>
            <el-form-item label="客户简称：" prop="AB_NAME" :label-width="formLabelWidth">
              <el-input v-model.trim="addForm.AB_NAME"></el-input>
            </el-form-item>
            <!-- <el-form-item label="首字母缩写：" prop="CODE" :label-width="formLabelWidth">
              <el-input v-model.trim="addForm.CODE"></el-input>
            </el-form-item> -->
            <el-form-item label="公司代码：" prop="COMPANY_CODE" :label-width="formLabelWidth">
              <el-input v-model.trim="addForm.COMPANY_CODE"></el-input>
            </el-form-item>
            <el-form-item label="联系人：" :label-width="formLabelWidth">
              <el-input v-model.trim="addForm.CONTACT_NAME"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" :label-width="formLabelWidth">
              <el-input v-model.trim="addForm.CONTACT_PHONE" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="地址：" :label-width="formLabelWidth">
              <el-input v-model="addForm.ADDRESS"></el-input>
            </el-form-item>
            <el-form-item label="加点：" :label-width="formLabelWidth">
              <el-input v-model.trim="addForm.ADD_POINT" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="合同起止日期：" :label-width="formLabelWidth">
              <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                v-model="addForm.START_END" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width: 100%"
                :unlink-panels="true" clearable>
              </el-date-picker>
            </el-form-item>
            <el-form-item label="是否自动签回：" :label-width="formLabelWidth">
              <el-radio-group v-model="addForm.IS_ALL_AUTOAUDIT">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item v-if="IF_CAN_MODIFY_PRICE === 0" label="录单是否可修改价格："> -->
            <el-form-item label="录单是否可修改价格：">
              <el-radio-group v-model="addForm.CAN_MODIFY_PRICE">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close('addForm')">取 消</el-button>
            <el-button size="small" @click="submitAction('addForm')">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
    <el-dialog title="批量导入" center :visible.sync="exportPriceDialog" width="400px">
      <el-form :inline="true" :model="exportPriceForm" ref="exportPriceForm" style="margin-top: 0">
        <el-form-item label="生效日期：">
          <el-date-picker v-model="exportPriceForm.EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="上传文件：">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
            :on-remove="handleRemove" :name="this.exportPriceForm.file" multiple :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="报价范围：">
          <el-select filterable v-model="exportPriceForm.GROUP" multiple placeholder="请选择">
            <el-option v-for="item in groupList" :key="item.ID" :label="item.CLIENT_AREA" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeExport()">取消</el-button>
        <el-button @click="submitExport()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 更新订单价格 -->
    <el-dialog title="销售价及订单价更新" center :visible.sync="updatePriceVisible" width="500px">
      <el-form ref="updatePriceForm" v-model="updatePriceForm" style="margin-left: 30px">
        <el-form-item label="生效日期：" label-width="100px">
          <el-date-picker v-model="updatePriceForm.EFFECTIVE_DATE" align="right" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" :picker-options="pickerOptions1" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
          :on-remove="handleRemove" :name="this.updatePriceForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
        <p style="color: #409eff" @click="downloadproTmp()">点击下载导入模板</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updatePriceVisible = false">取 消</el-button>
        <el-button @click="submitUpdate('importForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量匹配供应关系" center :visible.sync="exportRelationshipDialog" width="400px">
      <el-form :inline="true" :model="exportRelationshipForm" ref="exportRelationshipForm" style="margin-top: 0">
        <el-form-item label="上传文件：">
          <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess"
            :on-remove="handleRemove" :name="this.exportRelationshipForm.file" multiple :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <span @click="downLoadExpTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeExport()">取消</el-button>
        <el-button @click="submitExportShip()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入客户信息 -->
    <el-dialog title="导入客户信息" center :visible.sync="importFormVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="importForm" :model="importForm" style="padding-left: 30px;">
        <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
          :name="this.importForm.file" multiple :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
        </el-upload>
        <el-form-item>
          <span @click="downLoadResetTemp" style="color:#409EFF">点此下载导入模板</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close('importForm')">取 消</el-button>
        <el-button size="small" @click="submitEnter('importForm')" :loading="loading2">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 供应商绑定信息 -->
    <el-dialog title="供应商绑定信息" center :visible.sync="purchaseDialog" width="400px">
      <el-form size="small" ref="purchaseForm" :model="purchaseForm" style="padding-left: 30px;">
        <el-form-item label="绑定供应商：">
          <el-select filterable v-model="purchaseForm.PRINCIPAL" placeholder="请选择供应商" clearable>
            <el-option v-for="item in purchaseList" :key="item.PRINCIPAL_ID" :label="item.NAME"
              :value="item.PRINCIPAL_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="purchaseDialog = false">取 消</el-button>
        <el-button size="small" @click="submitPurchase()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 送货方绑定信息 -->
    <el-dialog title="送货方绑定信息" center :visible.sync="purchaseNewDialog" width="400px">
      <el-form size="small" ref="purchaseNewForm" :model="purchaseNewForm" style="padding-left: 30px;">
        <el-form-item label="绑定送货方：">
          <el-select filterable v-model="purchaseNewForm.TRUSTEE_ID" placeholder="请选择送货方" clearable>
            <el-option v-for="item in purchaseNewList" :key="item.TRUSTEE_ID" :label="item.NAME"
              :value="item.TRUSTEE_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="purchaseNewDialog = false">取 消</el-button>
        <el-button size="small" @click="submitNewPurchase()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 打印模板匹配 -->
    <el-dialog title="打印模板匹配" center :visible.sync="printDialog" width="400px">
      <el-form size="small" ref="printForm" :model="printForm" label-width="auto">
        <el-form-item label="模板名称：">
          <el-select filterable v-model="printForm.TEMPLATE_ID" placeholder="请选择供应商" clearable>
            <el-option v-for="item in printList" :key="item.TEMPLATE_ID" :label="item.TEMPLATE_NAME"
              :value="item.TEMPLATE_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="printDialog = false">取 消</el-button>
        <el-button size="small" @click="submitPrint()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 客户常用习惯 -->
    <el-dialog title="客户常用习惯" center :visible.sync="commonHabitsFormVisible" width="400px">
      <el-form size="small" ref="commonHabitsForm" v-model="commonHabitsForm" style="padding-left: 30px;" inline>
        <el-form-item label="客户习惯：">
          <el-input v-model="commonHabitsForm.COMMENT">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="commonHabitsFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitCommoHabits()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 批量导入客户编码 -->
    <el-dialog :visible.sync="importCustomerCodeDialog" title="批量导入客户编码" width="400px" center>
      <el-form>
        <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-remove="handleRemove"
          :on-success="handleSuccess" name="tmp" multiple :limit="1" accept=".xls,.xlsx" :file-list="fileList">
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb</div>
        </el-upload>
        <p @click="downLoadOrder" style="color: #409EFF;margin-top: 20px;cursor: pointer">点击下载导入模板</p>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="importCustomerCodeDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="batchImportCustomerCode">确认</el-button>
      </div>
    </el-dialog>
    <!-- 匹配客户 -->
    <el-dialog title="匹配客户" center :visible.sync="matchCustomerDialog" width="400px">
      <el-form size="small" style="padding-left: 30px;" inline label-suffix="：">
        <el-form-item label="客户">
          <el-select v-model="toBeMatchedCustomerID" filterable>
            <el-option v-for="{ ID, AB_NAME } in unmatchedCustomerList" :value="ID" :label="AB_NAME" :key="ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeMatchCustomer">取 消</el-button>
        <el-button size="small" @click="submitMatchCustomer">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改单位模式 -->
    <el-dialog title="修改单位模式" center :visible.sync="unitModeDialogVisible" width="430px" :close-on-click-modal="false">
      <el-form ref="unitModeForm" :model="unitModeForm" style="padding-left: 20px;">
        <el-form-item label="单位模式：">
          <el-select v-model="unitModeForm.UNIT_MODE" placeholder="请选择" style="width: 200px">
            <el-option label="跟随客户设置" :value="0"></el-option>
            <el-option label="强制公斤" :value="1"></el-option>
            <el-option label="强制斤" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="unitModeDialogVisible = false">取 消</el-button>
        <el-button size="small" @click="submitUnitMode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  customerList, addCustomer, stopCustomerFun, startCustomerFun, editCustomer, exportProject, exportDK, importCustomer,
} from 'api/customerManage';
import { getPriceGroupFun, updateUnitMode } from 'api/systemSetting';
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';
import util from '@/assets/common/util';

export default {
  data () {
    return {
      matchCustomerDialog: false,
      unmatchedCustomerList: [],
      toBeMatchedCustomerID: '',
      importCustomerCodeDialog: false,
      selectedList: [],
      judgeIS_ALL_AUTOAUDIT: ['否', '是'],
      IS_PRINCIPAL_CLIENT: ['普通供应', '代采'],
      // loading:false,
      loading1: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      addFormVisible: false,
      addForm: {
        IS_ALL_AUTOAUDIT: 0,
        CAN_MODIFY_PRICE: 0,
      },
      addFormTitle: '',
      formLabelWidth: '120px',
      printForm: {},
      printDialog: false,
      printList: [],
      rules: {
        NAME: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
        AB_NAME: [
          { required: true, message: '请输入客户简称', trigger: 'blur' },
        ],
        // CODE: [
        //   { required: true, message: '请输入首字母缩写', trigger: 'blur' },
        // ],
      },
      dialogFlag: 0,
      statusForm: {
        RELATION_STATUS: -1,
      },
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')) || [],
      submitFlag: 0,
      exportPriceDialog: false,
      exportPriceForm: {
        file: 'supplierPrice',
      },
      fileList: [],
      url: '',
      pickerOptions1: {
        // disabledDate(time) {
        //   return time.getTime() < Date.now() - 4 * 8.64e7;// 如果没有后面的-8.64e7就是不可以选择今天的
        // },
      },
      updatePriceVisible: false,
      updatePriceForm: {
        file: 'tmp',
      },
      PAGE_ID: '1070001', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 107000101: 0, 107000102: 0, 107000103: 0 },
      groupList: [],
      IF_CAN_MODIFY_PRICE: 0,
      showOrderType: ['系统下单', '自录订单', '系统下单+自录订单'],
      exportRelationshipDialog: false,
      exportRelationshipForm: {
        file: 'tmp',
      },
      importForm: {
        file: 'tmp',
      },
      importFormVisible: false,
      loading2: false,
      currentOrderFlag: 0,
      purchaseDialog: false,
      purchaseNewDialog: false,
      purchaseForm: {
        PRINCIPAL: '',
        ID: '',
      },
      purchaseNewForm: {},
      purchaseList: [],
      usePriceType: sessionStorage.getItem('PRICE_MODE'),
      commonHabitsForm: {
        COMMENT: '',
      },
      commonHabitsFormVisible: false,
      purchaseNewList: [],
      unitModeDialogVisible: false,
      unitModeForm: {
        RELATION_ID: '',
        UNIT_MODE: 0,
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now();// 如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
    };
  },
  computed: {
    // 是否使用副仓：存在多个副仓时才启用副仓筛选及所属仓列
    useSubWarehouse () {
      return this.subWarehouseList && this.subWarehouseList.length > 1;
    },
    showUnitModeColumn () {
      const config = JSON.parse(sessionStorage.getItem('config'));
      return config && config.ORDER_OUTBOUND_UNIT_MODE === 1;
    },
    STATUS_LIST () {
      return [{ status: -1, name: '全部' }, { status: 0, name: '禁用' }, { status: 1, name: '在用' }];
    },
    CUSTOMER_LIST () {
      return this.$store.state.SAVE_CUSTOMER_LIST;
    },
  },
  methods: {
    closeMatchCustomer () {
      this.toBeMatchedCustomerID = '';
      this.matchCustomerDialog = false;
    },
    submitMatchCustomer () {
      if (!this.toBeMatchedCustomerID) {
        this.$message.show({ text: '请选择要匹配的客户', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 29,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TC_ID: this.toBeMatchedCustomerID,
      };
      http.post(params).then(() => {
        this.$message.show({ text: '匹配成功', type: 'success' });
        this.closeMatchCustomer();
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    matchCustomer () {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 28,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((res) => {
        this.unmatchedCustomerList = res;
        this.matchCustomerDialog = true;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    downLoadOrder () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/tcProductsCodetemp.xls';
    },
    batchImportCustomerCode () {
      const params = {
        SERVICE_ID: '10203',
        OTYPE: 9,
        TC_ID_LIST: this.selectedList.map(({ TC_ID }) => TC_ID),
        FILE_NAME: this.url,
      };
      if (!this.url) {
        this.$message.show({ text: '请先上传文件', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        if (result[0].FILE_PATH == '') {
          this.$message.show({ text: '导入成功', type: 'success' });
          this.url = '';
          this.$refs.upload.clearFiles();
          this.importCustomerCodeDialog = false;
          this.queryTable();
        } else {
          this.$message.show({ text: '导入失败，失败原因查看EXCEL', type: 'error' });
          this.url = '';
          this.$refs.upload.clearFiles();
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.url = '';
        this.$refs.upload.clearFiles();
      });
    },
    onSelectionChange (val) {
      this.selectedList = val;
    },
    // 委托方数据拉取
    queryPurchsse () {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 19,
        TRUSTEE_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.purchaseList = result;
        }
      });
    },
    printTemplate (row) {
      if (row.TEMPLATE_ID == 0) {
        return '未匹配';
      }
      return row.TEMPLATE_NAME;
    },
    printChange (row) {
      this.printDialog = true;
      this.printForm = { ...row };
      if (this.printForm.TEMPLATE_ID == 0) {
        this.printForm.TEMPLATE_ID = '';
      }
    },
    queryPrint () {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 2,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
      };
      http.post(params).then((result) => {
        this.printList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitPrint () {
      const params = {
        SERVICE_ID: '12013',
        OTYPE: 6,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        TEMPLATE_ID: this.printForm.TEMPLATE_ID,
        IS_SUPPLIER_CLIENT: this.currentOrderFlag,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.currentOrderFlag == 0) {
        params.TC_ID = this.printForm.TC_ID;
      }
      if (this.currentOrderFlag == 1) {
        params.GYS_ID = this.printForm.GYS_ID;
      }
      if (this.printForm.TEMPLATE_ID) {
        params.TEMPLATE_ID = this.printForm.TEMPLATE_ID;
      } else {
        this.$message.show({ text: '请选择模板', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '匹配成功', type: 'success' });
        this.queryTable();
        this.printDialog = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleTabClick (tab, event) {
      this.currentOrderFlag = Number(tab.index);
      if (this.currentOrderFlag == 0) {
        this.queryTable();
      } else if (this.currentOrderFlag == 1) {
        this.queryTable();
      }
    },
    // 代采供应商绑定
    purchaseChange (row) {
      if (this.currentOrderFlag == 0) {
        this.purchaseForm.ID = row.TC_ID;
      } else {
        this.purchaseForm.ID = row.GYS_ID;
      }
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 27,
        PRINCIPAL_ID: Number(sessionStorage.getItem('tcId')),
        CLIENT_ID: this.purchaseForm.ID,
        IS_SUPPLIER_CLIENT: this.currentOrderFlag,
        // EXCLUDE_TRUSTEE_ID: row.ID,
      };
      http.post(params).then((result) => {
        if (result.length > 0) {
          this.purchaseNewList = result;
        }
        this.purchaseNewDialog = true;
      });
    },
    // 代采供应商绑定确认
    submitPurchase () {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 33,
        PRINCIPAL_ID: Number(sessionStorage.getItem('tcId')),
        TRUSTEE_ID: this.purchaseForm.PRINCIPAL,
        IS_SUPPLIER_CLIENT: this.currentOrderFlag,
        CUSTOM_ID: this.purchaseForm.ID,
      };
      http.post(params).then((result) => {
        this.purchaseDialog = false;
        this.$message.show({ text: '绑定成功', type: 'success' });
        this.queryTable();
      });
    },
    submitNewPurchase () {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 33,
        PRINCIPAL_ID: Number(sessionStorage.getItem('tcId')),
        TRUSTEE_ID: this.purchaseNewForm.TRUSTEE_ID,
        IS_SUPPLIER_CLIENT: this.currentOrderFlag,
        CUSTOM_ID: this.purchaseForm.ID,
      };
      http.post(params).then((result) => {
        this.purchaseNewDialog = false;
        this.$message.show({ text: '绑定成功', type: 'success' });
        this.queryTable();
      });
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // ----------------------------查看商品
    productsList (row) {
      sessionStorage.setItem('customerStatus', row.ORDER_TYPE);
      this.$router.push({ path: '/queryProducts/detail' });
      sessionStorage.setItem('TC_ID', row.TC_ID);
      sessionStorage.setItem('customerName', row.AB_NAME);
    },
    // ---------------------------分页
    handleChange () {
      this.queryTable();
    },
    // -----------------------------筛选
    filtrate () {
      this.currentPage = 1;
      this.queryTable();
    },
    downloadproTmp () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/gysUpdatePriceTemp.xlsx';
    },
    // ------------------------禁用--启用
    stopCustomer (row) {
      this.$confirm('您确定禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const data = {
            TC_ID: Number(row.TC_ID),
            SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          };
          stopCustomerFun(data)
            .then((res) => {
              this.$message.show({ text: '禁用成功', type: 'success' });
              this.queryTable();
            }).catch((err) => {
              this.$message.show({ text: err, type: 'error' });
            });
        }).catch(() => {
          this.$message.show({ type: 'info', text: '取消操作' });
        });
    },
    // 更新价格
    updatePrice (row) {
      this.updatePriceVisible = true;
      this.updatePriceForm.TC_ID = row.TC_ID;
    },
    // 导入模态框的提交
    submitUpdate () {
      if (!this.url || !this.updatePriceForm.EFFECTIVE_DATE) {
        this.$message.show({ text: '请上传文件并输入日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 37,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        EFFECTIVE_DATE: this.updatePriceForm.EFFECTIVE_DATE,
        FILE_NAME: this.url,
        TC_ID: this.updatePriceForm.TC_ID,
      };
      http.post(params)
        .then((result) => {
          this.$message.show({ text: '更新成功', type: 'success' });
          this.url = '';
          this.$refs.upload.clearFiles();
          this.updatePriceVisible = false;
          this.fileList = [];
          document.body.style.cursor = 'default';
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.url = '';
          this.$refs.upload.clearFiles();
          document.body.style.cursor = 'default';
        });
    },
    startCustomer (row) {
      this.$confirm('您确定启用该项目点吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {
          TC_ID: Number(row.TC_ID),
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        };
        startCustomerFun(data)
          .then((res) => {
            this.$message.show({ text: '启用成功', type: 'success' });
            this.queryTable();
          }).catch((err) => {
            this.$message.show({ text: err, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    // -------------------拉取数据
    queryTable () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        IS_SUPPLIER_CLIENT: this.currentOrderFlag,
        RELATION_STATUS: Number(this.statusForm.RELATION_STATUS),
      };
      if (this.statusForm.NAME) {
        params.TC_NAME = this.statusForm.NAME;
      }
      if (this.statusForm.SUB_WAREHOUSE && this.statusForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.statusForm.SUB_WAREHOUSE;
      }
      this.loading1 = true;
      customerList(params).then((res) => {
        if (res.length !== 0) {
          this.tableData = res[1].list;
          this.totalCount = res[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_CUSTOMER_LIST', {
            CONDITION: this.statusForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading1 = false;
      }).catch((err) => {
        this.loading1 = false;
        this.$message.show({ text: err, type: 'error' });
      });
    },
    projectList (row) {
      this.$router.push({ path: '/projectList/detail' });
      sessionStorage.setItem('customerId', row.TC_ID);
      sessionStorage.setItem('customerStatus', row.ORDER_TYPE);
      sessionStorage.setItem('add_point', row.ADD_POINT);
      sessionStorage.setItem('customerName', row.AB_NAME);
    },
    submitAdd (formName) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // this.loading = true
              const data = {
                NAME: this.addForm.NAME,
                AB_NAME: this.addForm.AB_NAME,
                COMPANY_CODE: this.addForm.COMPANY_CODE || '',
                // CODE: this.addForm.CODE,
                ADDRESS: this.addForm.ADDRESS || '',
                CONTACT_NAME: this.addForm.CONTACT_NAME || '',
                CONTACT_PHONE: this.addForm.CONTACT_PHONE || '',
                ADD_POINT: this.addForm.ADD_POINT || '',
                IS_ALL_AUTOAUDIT: this.addForm.IS_ALL_AUTOAUDIT ? this.addForm.IS_ALL_AUTOAUDIT : 0,
                CAN_MODIFY_PRICE: this.addForm.CAN_MODIFY_PRICE,
              };
              // if (this.addForm.CODE) {
              //   const reg = /[\u4E00-\u9FA5]/g;
              //   if (reg.test(this.addForm.CODE)) {
              //     this.$message.show({ text: '请不要输入汉字', type: 'warning' });
              //     document.body.style.cursor = 'default';
              //     return false;
              //   }
              // }
              if (this.addForm.START_END && this.addForm.START_END.length) {
                data.START_DATE = this.addForm.START_END[0];
                data.END_DATE = this.addForm.START_END[1];
              }

              addCustomer(data).then((res) => {
                this.$message.show({ text: '操作成功', type: 'success' });
                this.addFormVisible = false;
                this.addForm = {};
                this.queryTable();
                // this.loading = false
                document.body.style.cursor = 'default';
              }).catch((err) => {
                this.$message.show({ text: err, type: 'error' });
                // this.loading = false
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
              return false;
            }
          });
        } finally { }
      }
    },
    submitEdit (formName) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // this.loading = true
              const data = {
                NAME: this.addForm.NAME,
                AB_NAME: this.addForm.AB_NAME,
                COMPANY_CODE: this.addForm.COMPANY_CODE,
                // CODE: this.addForm.CODE,
                ADDRESS: this.addForm.ADDRESS,
                CONTACT_NAME: this.addForm.CONTACT_NAME,
                CONTACT_PHONE: this.addForm.CONTACT_PHONE,
                TC_ID: this.addForm.TC_ID,
                ADD_POINT: this.addForm.ADD_POINT,
                IS_ALL_AUTOAUDIT: this.addForm.IS_ALL_AUTOAUDIT ? this.addForm.IS_ALL_AUTOAUDIT : 0,
                CAN_MODIFY_PRICE: this.addForm.CAN_MODIFY_PRICE,
              };
              // if (this.addForm.CODE) {
              //   const reg = /[\u4E00-\u9FA5]/g;
              //   if (reg.test(this.addForm.CODE)) {
              //     this.$message.show({ text: '请不要输入汉字', type: 'warning' });
              //     document.body.style.cursor = 'default';
              //     return false;
              //   }
              // }
              if (this.addForm.START_END) {
                data.START_DATE = this.addForm.START_END[0];
                data.END_DATE = this.addForm.START_END[1];
              }
              editCustomer(data).then((res) => {
                this.$message.show({ text: '操作成功', type: 'success' });
                this.addFormVisible = false;
                this.addForm = {};
                this.queryTable();
                // this.loading = false
                document.body.style.cursor = 'default';
              }).catch((err) => {
                this.$message.show({ text: err, type: 'error' });
                // this.loading = false
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
              return false;
            }
          });
        } finally { }
      }
    },
    submitAction (formName) {
      if (this.submitFlag == 0) {
        this.submitAdd(formName);
      } else {
        this.submitEdit(formName);
      }
    },
    close (formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
      this.IF_CAN_MODIFY_PRICE = 0;
    },
    addCustomer () {
      this.IF_CAN_MODIFY_PRICE = 1;
      this.addFormVisible = true;
      this.submitFlag = 0;
      this.addForm = {
        IS_ALL_AUTOAUDIT: 0,
        CAN_MODIFY_PRICE: 0,
      };
      this.addFormTitle = '新增客户';
    },
    openEdit (row) {
      this.addFormVisible = true;
      this.addForm = { ...row, START_END: [row.START_DATE, row.END_DATE] };
      this.submitFlag = 1;
      this.addFormTitle = '修改客户';
    },
    codeManage (row) {
      this.$router.push({ name: 'tcCodeManage' });
      sessionStorage.setItem('customerId', row.TC_ID);
    },
    handleSuccess (response, file, fileList) {
      this.url = response.file_name;
    },
    handleRemove (file, fileList) {
      this.fileList = [];
      this.url = '';
    },
    openExport () {
      this.exportPriceDialog = true;
    },
    closeExport () {
      this.exportPriceDialog = false;
      this.exportRelationshipDialog = false;
    },
    exportRelationship () {
      this.exportRelationshipDialog = true;
    },
    queryGroup () {
      getPriceGroupFun()
        .then((result) => {
          this.groupList = result;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    submitExport () {
      if (!this.exportPriceForm.EFFECTIVE_DATE || this.exportPriceForm.GROUP == '' || !this.url) {
        this.$message.show({ text: '请选择生效日期和报价范围并上传文件', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10045',
        OTYPE: 27,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        EFFECTIVE_DATE: this.exportPriceForm.EFFECTIVE_DATE,
        FILE_NAME: this.url,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        isSecondOn: 1,
        isOnSale: 1,
        AREA_ID: this.exportPriceForm.GROUP,
      };
      http.post(params)
        .then((result) => {
          if (result.length == 0) {
            this.$message.show({ text: '导入成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.exportPriceDialog = false;
            this.fileList = [];
          } else {
            this.url = '';
            this.$refs.upload.clearFiles();
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
          }
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
          this.url = '';
          this.$refs.upload.clearFiles();
        });
    },
    submitExportShip () {
      const params = {
        SERVICE_ID: '10072',
        OTYPE: 22,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        FILE_NAME: this.url,
      };
      http.post(params)
        .then((result) => {
          if (result.length == 0) {
            this.$message.show({ text: '导入成功', type: 'success' });
          } else {
            this.$message.show({ text: '导入失败', type: 'error' });
            window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
          }
          this.url = '';
          this.$refs.upload.clearFiles();
          this.exportRelationshipDialog = false;
          this.fileList = [];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    exportCustomer () {
      const params = {
        SERVICE_ID: '10005',
        OTYPE: 11,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.statusForm.SUB_WAREHOUSE && this.statusForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.statusForm.SUB_WAREHOUSE;
      }
      http.post(params)
        .then((result) => {
          window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    exportProject () {
      exportProject().then((result) => {
        window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportDK () {
      exportDK().then((result) => {
        window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    downLoadExpTemp () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/batchImportrs.xls';
    },
    submitEnter () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // 执行代码
          const params = {
            FILE_NAME: this.url,
          };
          this.loading2 = true;
          importCustomer(params)
            .then((result) => {
              if (result[0].FILE_PATH) {
                this.$message.show({ text: '导入失败，查看下载文件', type: 'warning' });
                window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
              } else {
                this.$message.show({ text: '导入成功', type: 'success' });
                this.queryTable();
                this.importFormVisible = false;
              }
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          document.body.style.cursor = 'default';
          this.loading2 = false;
        }
      }
    },
    //   下载模板
    downLoadResetTemp () {
      window.location.href = 'https://service.linkda.com.cn/file/templates/pm2customerTemp.xls';
    },
    importCustomer () {
      this.importFormVisible = true;
    },
    // 查看人员
    persontList (row) {
      sessionStorage.setItem('customerId', row.TC_ID);
      this.$router.push({ name: 'personDetail' });
    },
    // 客户常用习惯
    commoHabits (row) {
      this.commonHabitsForm = { ...row };
      let params;
      if (this.commonHabitsForm.TC_ID) {
        params = {
          SERVICE_ID: '10005',
          TC_ID: this.commonHabitsForm.TC_ID,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          OTYPE: 24,
        };
      } else {
        params = {
          SERVICE_ID: '10005',
          GYS_ID: this.commonHabitsForm.GYS_ID,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
          OTYPE: 25,
        };
      }
      http.post(params).then((res) => {
        if (typeof (res) == 'string') {
          this.$set(this.commonHabitsForm, 'COMMENT', res);
        }
        this.commonHabitsFormVisible = true;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 提交客户常用习惯
    submitCommoHabits () {
      let params;
      if (this.commonHabitsForm.TC_ID) {
        params = {
          SERVICE_ID: '10005',
          OTYPE: 22,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          TC_ID: this.commonHabitsForm.TC_ID,
          COMMENT: this.commonHabitsForm.COMMENT,
        };
      } else {
        params = {
          SERVICE_ID: '10005',
          OTYPE: 23,
          GYS_ID: this.commonHabitsForm.GYS_ID,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        };
      }
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '更新客户习惯成功', type: 'success' });
          this.commonHabitsFormVisible = false;
          this.commonHabitsForm = {
            COMMENT: '',
          };
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 显示单位模式文案
    showUnitMode (mode) {
      const map = { 0: '跟随客户设置', 1: '强制公斤', 2: '强制斤' };
      return map[mode] !== undefined ? map[mode] : '';
    },
    // 打开修改单位模式弹窗
    openUnitModeDialog (row) {
      this.unitModeForm = {
        RELATION_ID: row.RELEATION_ID,
        UNIT_MODE: row.UNIT_MODE,
      };
      this.unitModeDialogVisible = true;
    },
    // 提交修改单位模式
    submitUnitMode () {
      updateUnitMode(this.unitModeForm).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.unitModeDialogVisible = false;
        this.queryTable();
      }).catch((e) => {
        this.$message.show({ text: e, type: 'error' });
      });
    },
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (JSON.stringify(this.CUSTOMER_LIST) != '{}' && this.CUSTOMER_LIST != undefined) {
      this.statusForm = this.CUSTOMER_LIST.CONDITION;
      this.currentPage = this.CUSTOMER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
    this.queryGroup();
    this.queryBeforeFun();
    this.queryPurchsse();
    this.queryPrint();
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/customerManage/customerList.vue